var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onUpdatePassword($event)
        }
      }
    },
    [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.userEditChangePasswordOldPassword))]),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.oldPassword,
                expression: "oldPassword"
              }
            ],
            staticClass: "form-control",
            attrs: {
              "data-old-password": "",
              type: "password",
              size: "30",
              required: ""
            },
            domProps: { value: _vm.oldPassword },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.oldPassword = $event.target.value
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.userEditChangePasswordNewPassword))]),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newPassword,
                expression: "newPassword"
              }
            ],
            staticClass: "form-control",
            attrs: {
              "data-new-password": "",
              type: "password",
              size: "30",
              required: ""
            },
            domProps: { value: _vm.newPassword },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newPassword = $event.target.value
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.T.userEditChangePasswordRepeatNewPassword))
        ]),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newPassword2,
                expression: "newPassword2"
              }
            ],
            staticClass: "form-control",
            class: _vm.invalidPasswordClass,
            attrs: {
              "data-new-password2": "",
              type: "password",
              size: "30",
              required: ""
            },
            domProps: { value: _vm.newPassword2 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newPassword2 = $event.target.value
              }
            }
          }),
          _vm.passwordMismatch
            ? _c("div", { staticClass: "invalid-message" }, [
                _vm._v(" " + _vm._s(_vm.T.passwordMismatch) + " ")
              ])
            : _vm._e()
        ])
      ]),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "btn btn-primary mr-2",
            attrs: {
              "data-save-changed-password": "",
              type: "submit",
              disabled: _vm.submitDisabled
            }
          },
          [_vm._v(" " + _vm._s(_vm.T.wordsSaveChanges) + " ")]
        ),
        _c(
          "a",
          { staticClass: "btn btn-cancel", attrs: { href: "/profile/" } },
          [_vm._v(_vm._s(_vm.T.wordsCancel))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }